
<div class="icondialog"><mat-icon >done</mat-icon></div>

<h1 mat-dialog-title></h1>
<div mat-dialog-content>

	
  VOTRE DEMANDE A BIEN ÉTÉ PRISE EN COMPTE
 
</div>
<div mat-dialog-actions>
  <button mat-button class="appbutton" [mat-dialog-close]="data.animal" cdkFocusInitial style="text-align: center;">Ok</button>
</div>

<style>

	.mat-dialog-content{
		text-align: center;
		color: var(--text-color);
		font-family: Regular;
		font-size: 18px;
	}
.mat-dialog-actions {
	width: 25%;
    margin: 0 auto;
}
.dialogation .mat-dialog-container {
	background-color: red;
}
</style>